// extracted by mini-css-extract-plugin
export default {"section":"section_section__mzPFA","heading":"section_heading__Z0ydJ","extra":"section_extra__QWSbU"};